export default __webpack_public_path__ + "static/media/circle-plus-blue.26717981.svg";